'use strict';

var templates = require('../templates');
var fobclient = require('..');
var StrukturiertesPromotionsprogramm = require('../entity').StrukturiertesPromotionsprogramm;

module.exports = function (connection) {
  return {
    byFinanzierungEquals: function byFinanzierungEquals(finanzierung, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'byFinanzierungEquals', 'finanzierung')(finanzierung, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byPromProgTypEquals: function byPromProgTypEquals(promprogtyp, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'byPromProgTypEquals', 'promprogtyp')(promprogtyp, additionalParams);
    },
    byRelevantFuerWeitereEquals: function byRelevantFuerWeitereEquals(relevantfuerweitere, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'byRelevantFuerWeitereEquals', 'relevantfuerweitere')(relevantfuerweitere, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    bySprecherEquals: function bySprecherEquals(sprecher, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'bySprecherEquals', 'sprecher')(sprecher, additionalParams);
    },
    byTitelEquals: function byTitelEquals(titel, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'byTitelEquals', 'titel')(titel, additionalParams);
    },
    byTitelLike: function byTitelLike(titel, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'byTitelLike', 'titel')(titel, additionalParams);
    },
    byWeitereOrganisationseinheitenEquals: function byWeitereOrganisationseinheitenEquals(weitereorganisationseinheiten, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'byWeitereOrganisationseinheitenEquals', 'weitereorganisationseinheiten')(weitereorganisationseinheiten, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'findAll', 'page')(page, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'findOne', 'projection')(projection, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(StrukturiertesPromotionsprogramm, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(StrukturiertesPromotionsprogramm, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('strukturiertespromotionsprogramm')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/strukturiertesPromotionsprogramm.js
// module id = Lgny
// module chunks = 0